import common from './ko/common';

// pages
import authPage from './ko/pages/auth';
import dashboardPage from './ko/pages/dashboard';
import studentsPage from './ko/pages/students';
import sessionHistoryPage from './ko/pages/sessionHistory';
import sessionManagerPage from './ko/pages/sessionManager';
import mypagePage from './ko/pages/mypage';
import onboardingPage from './ko/pages/onboarding';
// modules
import moduleCommon from './ko/modules/moduleCommon';
// components
import headerComponents from './ko/components/header';
import sidebarComponents from './ko/components/sidebar';
import customSessionManagerPage from './ko/pages/customSessionManager';

const messages = {
    ko: {
        common,
        pages: {
            onboarding: onboardingPage,
            auth: authPage,
            dashboard: dashboardPage,
            students: studentsPage,
            sessionManager: sessionManagerPage,
            customSessionManager: customSessionManagerPage,
            sessionHistory: sessionHistoryPage,
            mypage: mypagePage,
        },
        modules: {
            common: moduleCommon,
        },

        components: {
            header: headerComponents,
            sidebar: sidebarComponents,
        },
    },
};

export default messages;
